<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ busenaTitle }}</h2>
      </v-card-title>
      <v-card-text class="modalText pt-2 pb-2">
        <el-overlay-loading :loading="loading && !loadingRegistravimas" />

        <template v-if="showIspejimas">
          <v-alert dense outlined type="warning" class="ispejimas mb-0">
            {{ ispejimas }}
          </v-alert>
        </template>
        <check-errors :modal="true" v-if="!loading && isCheckErrors" />

        <v-card class="mb-2 py-4">
          <v-card-text>
            <template v-if="loading">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="pb-3" v-if="loadingRegistravimas">
                    Vyksta duomenų įrašymas, neuždarykite naršyklės
                  </div>
                  <v-skeleton-loader type="paragraph"></v-skeleton-loader>
                </v-col>
              </v-row>
            </template>
            <template v-if="!loading">
              <v-row no-gutters>
                <v-col cols="12">
                  <span v-html="busenaMessage" />
                </v-col>
              </v-row>

              <template v-if="canChangeBusena">
                <template v-if="isGrazintas || isAtmestas">
                  <template v-if="showNtrVadovai">
                    <v-row>
                      <v-col cols="12" md="12">
                        <el-checkbox
                          label="Turiu teisę tvirtinti pats"
                          tooltip="Modalas būsena. Turiu teisę tvirtinti pats"
                          :readonly="isAprasymas"
                          v-model="vadovasPats"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="!vadovasPats">
                      <v-col cols="12" md="12">
                        <el-autocomplete
                          required
                          :items="ntrVadovaiList"
                          itemvalue="value"
                          itemtext="text"
                          label="NTR vadovas"
                          :readonly="isAprasymas"
                          :disabled="vadovasPats"
                          v-model="ntrVadovas"
                        />
                      </v-col>
                    </v-row>
                  </template>
                  <v-row>
                    <template v-if="isGrazintas">
                      <v-col cols="12" md="6">
                        <el-date-picker
                          :required="!isAprasymas"
                          :label="busenaTekstas.terminas"
                          :tooltip="busenaTekstas.terminasTooltip"
                          :readonly="isAprasymas || terminasReadonly"
                          v-model="status.zug_terminas"
                        />
                      </v-col>
                    </template>
                    <template v-if="isGrazintas && isSTSRRegistrat">
                      <v-col cols="12" md="12">
                        <el-autocomplete
                          :required="!isAprasymas"
                          :items="priezastysItems"
                          itemvalue="value"
                          itemtext="text"
                          :label="busenaTekstas.priezastis"
                          :tooltip="busenaTekstas.priezastisTooltip"
                          :readonly="isAprasymas"
                          v-model="status.bus_priezastis_kla_id"
                        />
                      </v-col>
                      <v-col cols="12" md="12">
                        <el-textarea
                          :required="!isAprasymas"
                          :label="busenaTekstas.aprasymas"
                          :tooltip="busenaTekstas.aprasymasTooltip"
                          :counter="2000"
                          :readonly="isAprasymas"
                          validate-key="grazintas_aprasymas"
                          v-model="status.bus_priezastis_aprasymas"
                        />
                      </v-col>
                    </template>
                    <template v-if="isGrazintas && isNTRRegistrat">
                      <v-col cols="12" md="12">
                        <el-textarea
                          :required="!isAprasymas"
                          :label="busenaTekstas.motyvas"
                          :tooltip="busenaTekstas.motyvasTooltip"
                          :counter="2000"
                          :readonly="isAprasymas"
                          validate-key="grazintas_motyvas"
                          v-model="status.bus_priezastis_aprasymas"
                        />
                      </v-col>
                      <v-col cols="12" md="12">
                        <el-textarea
                          :required="!isAprasymas"
                          :label="busenaTekstas.pagrindas"
                          :tooltip="busenaTekstas.pagrindasTooltip"
                          :counter="2000"
                          :readonly="isAprasymas"
                          validate-key="grazintas_pagrindas"
                          v-model="status.bus_priezastis_pagrindas"
                        />
                      </v-col>
                    </template>
                    <template v-if="isAtmestas && isSTSRRegistrat">
                      <v-col cols="12" md="12">
                        <el-textarea
                          :required="!isAprasymas"
                          :label="busenaTekstas.atmetimasAprasymas"
                          :tooltip="busenaTekstas.atmetimasAprasymasTooltip"
                          :counter="2000"
                          :readonly="isAtmetimoAprasymasReadonly"
                          v-model="status.bus_atmetimo_priezastis_aprasymas"
                        />
                      </v-col>
                    </template>
                    <template v-if="isAtmestas && isNTRRegistrat">
                      <v-col cols="12" md="12">
                        <el-textarea
                          :required="!isAprasymas"
                          :label="busenaTekstas.motyvas"
                          :tooltip="busenaTekstas.motyvasTooltip"
                          :counter="2000"
                          :readonly="isAprasymas"
                          validate-key="atmestas_motyvas"
                          v-model="status.bus_atmetimo_priezastis_aprasymas"
                        />
                      </v-col>
                      <v-col cols="12" md="12">
                        <el-textarea
                          :required="!isAprasymas"
                          :label="busenaTekstas.pagrindas"
                          :tooltip="busenaTekstas.pagrindasTooltip"
                          :counter="2000"
                          :readonly="isAprasymas"
                          validate-key="atmestas_pagrindas"
                          v-model="status.bus_atmetimo_priezastis_pagrindas"
                        />
                      </v-col>
                    </template>
                  </v-row>
                </template>

                <!-- <template v-if="isTerminoPraleidimas">
                  <v-row>
                    <v-col cols="12" md="12">
                      <el-textarea
                        :required="!isAprasymas"
                        :label="busenaTekstas.terminoPraleidimoPriezastis"
                        :tooltip="
                          busenaTekstas.terminoPraleidimoPriezastisTooltip
                        "
                        :counter="2000"
                        :readonly="isAprasymas"
                        v-model="status.bus_termino_praleidimo_priezastis"
                      />
                    </v-col>
                  </v-row>
                </template> -->
                <modal-busena-bylos
                  v-if="showBusenaBylos && showModal"
                  :busena="busena"
                  @stopLoading="stopLoadingBylos"
                />

                <template v-if="openSign">
                  <modal-sign
                    :open-sign="openSign"
                    :unsigned-bylos="unsignedBylos"
                    @signDone="signDone"
                  />
                </template>
              </template>
            </template>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          v-if="atsauktiButton"
          @click.native="cancelData()"
          :loading="loading"
        >
          {{ atsauktiText }}
        </el-button>
        <el-button
          @click.native="cancelAtmetimas()"
          v-if="showAtsauktiAtmetimas"
          :loading="loading"
        >
          Atšaukti sprendimą
        </el-button>
        <el-button
          primary
          @click.native.stop="submit()"
          v-if="canSubmit"
          :loading="loading"
        >
          {{ submitText }}
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../mixins/userRole'
import HipotekaMap from './../hipoteka/hipotekaMap'
import CheckErrors from './../hipoteka/CheckErrors'
import ModalBusenaBylos from './ModalBusenaBylos'
import ModalSign from './ModalSign'

export default {
  name: 'ModalBusena',
  components: { CheckErrors, ModalBusenaBylos, ModalSign },
  mixins: [userRole],
  props: {
    busena: String,
    busenaTekstui: String,
    value: Boolean,
    isSign: Boolean,
    perskaiciuotiTermina: Boolean,
    action: { type: String, default: 'Busena' },
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loading: false,
      loadingRegistravimas: false,
      loadingBylos: false,
      klaidos: [],
      priezastys: [],
      unsignedBylos: [],

      status: {
        can_change: true,
        bylu_generavimas: 0,
        pasirasymas: false,
        pasirasymas_klaida: null,
        zug_terminas: null,
        zug_vadovas_pats: false,
        terminas_redaguojamas: null,
        bus_priezastis_kla_id: null,
        bus_priezastis_aprasymas: null,
        bus_priezastis_pagrindas: null,
        bus_atmetimo_priezastis_aprasymas: null,
        bus_atmetimo_priezastis_pagrindas: null,
        redaguojamas_aprasymas: null,
        termino_praleidimo_priezastis: false,
        bus_termino_praleidimo_priezastis: null,
        teikejas: null,
        esama_busena: null,
        busenos_veiksmas: null,
        is_savitarna: false,
      },

      openSign: false,
      savedAprasymas: false,
      ntrVadovai: [],
      ntrVadovas: null,
      ispejimas: null,
      vadovasPats: false,
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'savitarnaKrepselisUrl',
      'signNtrVadovas',
      'pasirasymasVadovas',
      'registratoriaiAktyvus',
    ]),
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    modalAction() {
      return this.action
    },
    atsauktiText() {
      return this.role('RG_NTR_vadovas') ? 'Uždaryti' : 'Atšaukti'
    },
    showAtsauktiAtmetimas() {
      return (
        this.role('RG_NTR_vadovas') &&
        (this.isAtmestas || this.isGrazintas || this.isNepatikslintas) &&
        this.savedAprasymas &&
        (this.esamaBusena === 'perduotas' ||
          this.esamaBusena === 'grazintas' ||
          this.esamaBusena === 'nepatikslintas')
      )
    },
    busenaTekstas() {
      return (
        (this.status.busenos_veiksmas &&
          HipotekaMap['busenaTekstas'][this.status.busenos_veiksmas]) ??
        []
      )
    },
    busenaTitle() {
      return this.busenaTekstas.title
    },
    busenaSubmitMessage() {
      if (this.allSigned) {
        return ''
      }
      if (this.isPasirasymas && this.role('DT_notaro_padejejas')) {
        return `Ar norite perduoti sandorį pasirašymui <b>${this.status
          .teikejas ?? ''}</b>?`
      }
      if (this.busenaTekstas.message) {
        return this.busenaTekstas.message
      }
      return ''
    },
    busenaCancelMessage() {
      return this.status.pasirasymas
        ? this.status.pasirasymas_klaida
        : this.busenaTekstas.messageCancel
    },
    busenaMessage() {
      return this.canChangeBusena
        ? this.busenaSubmitMessage
        : this.busenaCancelMessage
    },
    isCheckErrors() {
      return this.busenaTekstas.checkErrors
    },
    errorCount() {
      if (this.loading) {
        return -1
      }
      if (!this.isCheckErrors) {
        return 0
      }
      return this.klaidos.filter(item => {
        return item.type === 'error'
      }).length
    },
    noError() {
      return this.errorCount === 0
    },
    isAprasymas() {
      return this.isSigning || this.savedAprasymas
    },
    isAtmetimoAprasymasReadonly() {
      if (
        this.status.busenos_veiksmas === 'atmesti' &&
        !this.status.redaguojamas_aprasymas
      ) {
        return true
      }
      return this.isSigning || this.savedAprasymas
    },
    showBusenaBylos() {
      return (
        this.isSigning ||
        (this.status.busenos_veiksmas == 'iregistruoti' &&
          this.status.is_savitarna) ||
        (this.status.busenos_veiksmas !== 'rengti' &&
          !this.isIregistruotas &&
          (!this.isGrazintas || this.savedAprasymas) &&
          (!this.isAtmestas || this.savedAprasymas))
      )
    },
    canChangeBusena() {
      return (
        this.status.can_change &&
        (this.noError ||
          this.status.busenos_veiksmas === 'grazinti' ||
          this.status.busenos_veiksmas === 'atmesti')
      )
    },
    canSubmit() {
      return (
        this.canChangeBusena &&
        (!this.loadingBylos || !this.showBusenaBylos) &&
        !this.openSign
      )
    },
    isPasirasymas() {
      return this.status.pasirasymas
    },
    needSign() {
      return (
        this.unsignedBylos.length > 0 &&
        this.isPasirasymas &&
        !this.role('DT_notaro_padejejas')
      )
    },
    submitText() {
      if (this.status.busenos_veiksmas === 'moketi') {
        return 'Mokėti'
      }
      return this.needSign ? 'Pasirašyti' : 'Tęsti'
    },
    esamaBusena() {
      return this.status.esama_busena
    },
    isPerduotas() {
      return (
        this.busena &&
        HipotekaMap['objektasBusena'][this.busena].key === 'perduotas'
      )
    },
    isLaukiaPatvirtinimo() {
      return (
        this.busena &&
        HipotekaMap['objektasBusena'][this.busena].key === 'laukia_patvirtinimo'
      )
    },
    isGrazintas() {
      return (
        this.busena &&
        HipotekaMap['objektasBusena'][this.busena].key === 'grazintas'
      )
    },
    isIregistruotas() {
      return (
        this.busena &&
        HipotekaMap['objektasBusena'][this.busena].key === 'iregistruotas'
      )
    },
    isAtmestas() {
      return (
        this.busena &&
        HipotekaMap['objektasBusena'][this.busena].key === 'atmestas'
      )
    },
    priezastysItems() {
      return this.priezastys.map(item => {
        return item
      })
    },
    isTerminoPraleidimas() {
      return this.status.termino_praleidimo_priezastis
    },
    isSigning() {
      return this.isSign
    },
    allSigned() {
      return this.isSigning && this.unsignedBylos.length === 0
    },
    atsauktiButton() {
      return !this.canChangeBusena || !this.allSigned
    },
    ntrVadovaiList() {
      return this.ntrVadovai.map(vadovas => {
        return vadovas
      })
    },
    showNtrVadovai() {
      return this.ntrVadovaiList.length > 0
    },
    showIspejimas() {
      return this.ispejimas !== null
    },
    isNTRRegistrat() {
      return (
        this.roleOr(['RG_NTR_registrat', 'RG_NTR_vadovas']) &&
        this.registratoriaiAktyvus === 'NTR'
      )
    },
    isSTSRRegistrat() {
      return (
        this.roleOr(['RG_STSR_registrat']) &&
        this.registratoriaiAktyvus === 'STSR'
      )
    },
    terminasReadonly() {
      return !this.status.terminas_redaguojamas
    },
  },
  created() {
    if (this.isSigning) {
      this.ntrVadovas = this.signNtrVadovas
    }
    if (this.showModal) {
      this.savedAprasymas =
        this.roleRG && !this.pasirasymasVadovas ? false : true

      if (!this.savedAprasymas && !this.isSigning) {
        this.vadovasPats = this.roleRGVadovas
      }

      this.getStatus()
    }
  },
  methods: {
    getStatus() {
      this.loading = true

      const data = {
        negeneruoti_bylu: this.isSigning,
        perskaiciuoti_termina: this.perskaiciuotiTermina,
      }

      this.$axios
        .post(`objektas/${this.objektasID}/busena/${this.busena}/status`, data)
        .then(res => {
          this.status.can_change = res.data.status.can_change
          this.status.bylu_generavimas = res.data.status.bylu_generavimas
          this.status.pasirasymas = res.data.status.pasirasymas
          this.status.pasirasymas_klaida = res.data.status.pasirasymas_klaida
          this.status.zug_terminas = res.data.status.zug_terminas
          this.status.zug_vadovas_pats = res.data.status.zug_vadovas_pats
          this.status.terminas_redaguojamas =
            res.data.status.terminas_redaguojamas
          this.status.termino_praleidimo_priezastis =
            res.data.status.termino_praleidimo_priezastis
          this.status.teikejas = res.data.status.teikejas
          this.status.teikejas = res.data.status.teikejas
          this.status.esama_busena = res.data.status.esama_busena
          this.status.busenos_veiksmas = res.data.status.busenos_veiksmas
          this.status.is_savitarna = res.data.status.is_savitarna

          this.klaidos = res.data.klaidos
          this.priezastys = res.data.priezastys
          this.ntrVadovai = res.data.vadovai
          this.ispejimas = res.data.ispejimas

          if (res.data.busenosIstorija) {
            this.status.bus_priezastis_kla_id =
              res.data.busenosIstorija.bus_priezastis_kla_id
            this.status.bus_priezastis_aprasymas =
              res.data.busenosIstorija.bus_priezastis_aprasymas
            this.status.bus_priezastis_pagrindas =
              res.data.busenosIstorija.bus_priezastis_pagrindas
            this.status.bus_atmetimo_priezastis_aprasymas =
              res.data.busenosIstorija.bus_atmetimo_priezastis_aprasymas
            this.status.bus_atmetimo_priezastis_pagrindas =
              res.data.busenosIstorija.bus_atmetimo_priezastis_pagrindas
            this.status.redaguojamas_aprasymas =
              res.data.status.redaguojamas_aprasymas
            if (this.status.termino_praleidimo_priezastis) {
              this.status.bus_termino_praleidimo_priezastis =
                res.data.busenosIstorija.bus_termino_praleidimo_priezastis
            }
          }

          if (this.savedAprasymas || this.isSigning) {
            this.vadovasPats = this.status.zug_vadovas_pats
          }

          this.$store.dispatch(
            'checkErrors',
            this.isCheckErrors ? this.klaidos : null
          )
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadingBylos = true
          this.loading = false
          this.$emit('loadedBusena')
        })
    },
    saveAprasymas() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true

          const data = {
            obj_id: this.objektasID,
            vadovas_id: this.ntrVadovas,
            vadovas_pats: this.vadovasPats,
            ...this.status,
          }

          this.$axios
            .post(
              `objektas/${this.objektasID}/busena/${this.busena}/aprasymas`,
              data
            )
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              this.$store.dispatch('checkErrors', null)
              this.loadingBylos = true
              this.savedAprasymas = true
              this.getStatus()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    changeBusena() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          this.loadingRegistravimas = true
          const data = {
            obj_id: this.objektasID,
            vadovas_id: this.ntrVadovas,
            ...this.status,
          }

          this.$axios
            .post(`objektas/${this.objektasID}/busena/${this.busena}`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              this.$store.dispatch('checkErrors', null)
              if (res.data.krepselis) {
                this.gotoKrepselis(res.data.krepselis_id)
              } else {
                this.loading = false
                this.loadingRegistravimas = false
                this.confirmData()
              }
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
              this.loading = false
              this.loadingRegistravimas = false
              this.confirmData()
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    cancelAtmetimas() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true

          const data = { obj_id: this.objektasID }

          this.$axios
            .post(
              `objektas/${this.objektasID}/busena/${this.busena}/atsaukimas`,
              data
            )
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)
              this.$store.dispatch('checkErrors', null)
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
              this.confirmData()
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    savePatvirtinimas() {
      this.loading = false
      this.confirmData()
    },
    confirmData() {
      this.$emit('confirm' + this.modalAction)
      this.closeModal()
    },
    cancelData() {
      this.$emit('cancel' + this.modalAction)
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
      this.$store.dispatch('signType', null)
    },
    stopLoadingBylos(unsignedBylos) {
      this.unsignedBylos = unsignedBylos
      this.loadingBylos = false
    },
    submitBusena() {
      if (this.isLaukiaPatvirtinimo) {
        this.savePatvirtinimas()
        return
      }
      if ((this.isGrazintas || this.isAtmestas) && !this.isAprasymas) {
        this.saveAprasymas()
        return
      }
      this.changeBusena()
    },
    submitSign() {
      this.$store.dispatch('signNtrVadovas', this.ntrVadovas)
      if (this.isSigning) {
        this.openSign = true
      } else {
        this.$store.dispatch('signBusena', this.busena)
        this.$store.dispatch('signType', null).then((this.openSign = true))
      }
    },
    signDone() {
      //
    },
    submit() {
      if (this.needSign) {
        this.submitSign()
      } else {
        this.submitBusena()
      }
    },
    cancel() {
      this.cancelData()
    },
    gotoKrepselis(krepselis_id = null) {
      this.loading = true
      if (krepselis_id) {
        window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${krepselis_id}`
        return
      }
      window.location.href = this.savitarnaKrepselisUrl
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalText {
  max-height: calc(100vh - 250px);
  overflow: auto;
  overflow-anchor: none;
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
.ispejimas {
  background-color: #fff !important;
  color: #e4800d !important;
}
</style>
